const ScoreProps = {
	1: { name: 'Critical', color: 'text-danger' },
	2: { name: 'Poor', color: 'text-warning' },
	3: { name: 'Fair', color: 'text-warning' },
	4: { name: 'Good', color: 'text-success' },
	5: { name: 'Excellent', color: 'text-success' },
	default: { name: 'Unrated', color: ''},
};

export default ScoreProps;